import { useReactiveVar } from '@apollo/client';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import type React from 'react';
import { LOCAL_STORAGE_KEYS } from 'src/constants';
import styles from 'src/HomePage/DrawerAndPushedContents/LeftSideDrawer/LeftSideDrawerStyles';
import LeftSideDrawerContent from 'src/HomePage/DrawerAndPushedContents/LeftSideDrawerContent/LeftSideDrawerContent';
import useDrawerResize from 'src/hooks/useDrawerResize';
import viewStateVar from 'src/store/viewState';

const DRAWER_MIN_WIDTH = 20;

const LeftSideDrawer: React.FC = () => {
  const viewState = useReactiveVar(viewStateVar);
  const { width, resizeHandleProps } = useDrawerResize({
    side: 'left',
    min: 200,
    max: 480,
    defaultWidth: 240,
    storageKey: LOCAL_STORAGE_KEYS.LEFT_DRAWER_WIDTH,
  });
  const classes = styles({ open: viewState.showLeftSidebar, width });

  const openDrawer = (): void => {
    const opening = !viewState.showLeftSidebar;
    viewStateVar({
      ...viewStateVar(),
      showLeftSidebar: opening,
      ...(opening && {
        showHorizontal: false,
        showRightSidebar: false,
      }),
    });
  };

  return (
    <Drawer
      open={viewState.showLeftSidebar}
      style={{ width: viewState.showLeftSidebar ? width : DRAWER_MIN_WIDTH }}
      anchor="left"
      className={classes.drawer}
      variant="permanent"
      PaperProps={{ style: { width: viewState.showLeftSidebar ? width : DRAWER_MIN_WIDTH } }}
    >
      <div style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 64px)', scrollbarGutter: 'stable' }}>
        {viewState.showLeftSidebar && <LeftSideDrawerContent />}
      </div>
      {viewState.showLeftSidebar && <div className={classes.resizeHandle} {...resizeHandleProps} />}
      <IconButton
        className={clsx(classes.drawerIcon)}
        onClick={openDrawer}
        style={{
          left: viewState.showLeftSidebar ? width - DRAWER_MIN_WIDTH : 2,
          transform: viewState.showLeftSidebar ? 'rotate(90deg)' : 'rotate(270deg)',
        }}
        size="large"
      >
        <DragHandleIcon />
      </IconButton>
    </Drawer>
  );
};

export default LeftSideDrawer;
